<glxy-form-field>
  <glxy-label>{{ label | translate }}</glxy-label>

  <mat-datepicker-toggle
    matPrefix
    [for]="meetingScheduleDate"
    meetingSchedulerDatePickerNavigation
    (prevClicked)="onPrevMonth()"
    (nextClicked)="onNextMonth()"
    data-calendar-id="meeting-calendar-1"
  ></mat-datepicker-toggle>
  <input
    matInput
    [placeholder]="placeholder | translate"
    [matDatepicker]="meetingScheduleDate"
    (click)="meetingScheduleDate.open()"
    [matDatepickerFilter]="validateDateFn"
    [value]="selectedDate"
    (dateChange)="onDateChange($event.value)"
    [min]="calenderDateStart"
    [max]="calenderDateEnd"
  />
  <mat-datepicker #meetingScheduleDate [disabled]="isCalenderDisabled" />
</glxy-form-field>
